import * as chrono from "chrono-node";
import { DateTime } from "luxon";
function getCandidateDayMonthParts(dayMonth) {
    if (dayMonth.length === 2) {
        return [[dayMonth.slice(0, 1), dayMonth.slice(1)]];
    }
    if (dayMonth.length === 3) {
        return [
            [dayMonth.slice(0, 2), dayMonth.slice(2)],
            [dayMonth.slice(0, 1), dayMonth.slice(1)],
        ];
    }
    if (dayMonth.length === 4) {
        return [[dayMonth.slice(0, 2), dayMonth.slice(2)]];
    }
    return [];
}
function parseCandidateDate(dayMonth, year) {
    for (const [dayPart, monthPart] of getCandidateDayMonthParts(dayMonth)) {
        const parsedDate = parseCandidateDateFromParts(dayPart, monthPart, year);
        if (parsedDate) {
            return parsedDate;
        }
    }
    return undefined;
}
function parseCandidateDateFromParts(dayPart, monthPart, year) {
    const parsedDate = DateTime.fromObject({
        year,
        month: Number.parseInt(monthPart, 10),
        day: Number.parseInt(dayPart, 10),
    });
    if (parsedDate.isValid) {
        return parsedDate;
    }
    return undefined;
}
function resolveTwoDigitYear(year, twoDigitYearCentury = "future") {
    const yearNumber = Number.parseInt(year, 10);
    return (twoDigitYearCentury === "past" ? 1900 : 2000) + yearNumber;
}
function denseNumericDateParse(date, options) {
    if (!/^\d{4,8}$/.test(date)) {
        return;
    }
    if (date.length <= 6) {
        const parsedDate = parseCandidateDate(date.slice(0, -2), resolveTwoDigitYear(date.slice(-2), options?.twoDigitYearCentury));
        if (parsedDate) {
            return parsedDate;
        }
    }
    if (date.length >= 6) {
        const fourDigitYear = date.slice(-4);
        if (/^(19|20)\d{2}$/.test(fourDigitYear)) {
            const parsedDate = parseCandidateDate(date.slice(0, -4), Number.parseInt(fourDigitYear, 10));
            if (parsedDate) {
                return parsedDate;
            }
        }
    }
    return undefined;
}
function delimitedNumericDateParse(date, options) {
    const parts = date.split("-").filter(Boolean);
    if (parts.length !== 3 || parts.some((part) => !/^\d+$/.test(part))) {
        return;
    }
    const [dayPart, monthPart, yearPart] = parts;
    if (!dayPart || !monthPart || !yearPart) {
        return;
    }
    if (yearPart.length === 2) {
        return parseCandidateDateFromParts(dayPart, monthPart, resolveTwoDigitYear(yearPart, options?.twoDigitYearCentury));
    }
    if (yearPart.length === 4) {
        return parseCandidateDateFromParts(dayPart, monthPart, Number.parseInt(yearPart, 10));
    }
    return undefined;
}
export function fuzzyDateParse(date = "", options) {
    const trimmedDate = date.trim();
    const denseNumericDate = denseNumericDateParse(trimmedDate, options);
    if (denseNumericDate) {
        return denseNumericDate;
    }
    const normalizedDate = trimmedDate
        .replaceAll(/[^\d]/g, "-")
        .replace(/(-)\1+/g, "$1");
    const delimitedDate = delimitedNumericDateParse(normalizedDate, options);
    if (delimitedDate) {
        return delimitedDate;
    }
    const parsedDate = chrono.nl.parseDate(trimmedDate);
    if (!parsedDate) {
        return DateTime.invalid("invalid input");
    }
    return DateTime.fromJSDate(parsedDate);
}
